import React, { Suspense } from "react";
import ServerSideService from "../../utilities/serverSideService";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SuccessAlert } from "wbm-generic-components";

const WbmSelectAddress = React.lazy(
  () =>
    import(
      /* webpackMode: "eager" */
      /* webpackChunkName: "slide-outs" */
      "./wbmSelectedAddress"
    )
);

export interface IWbmSelectAddressWrapperProps {
  fallback: React.ReactElement;
  closeCallback: () => void;
  [key: string]: unknown;
}

function WbmSelectAddressWrapper(props: IWbmSelectAddressWrapperProps) {
  const ErrorFallbackRender = (fallbackProps: FallbackProps): JSX.Element => {
    props.closeCallback();

    return (
      <SuccessAlert
        timerLengthInMS={3500}
        danger
        dangerText="Please try again. If the problem persists, please call 1-888-WB-MASON."
        dangerAttentionText="An error has occurred!"
        onClickClose={fallbackProps.resetErrorBoundary}
      />
    );
  };

  return (
    <>
      {ServerSideService.isServerSide ? undefined : (
        <ErrorBoundary fallbackRender={ErrorFallbackRender}>
          <Suspense fallback={props.fallback}>
            <WbmSelectAddress {...props} />
          </Suspense>
        </ErrorBoundary>
      )}
    </>
  );
}

export default WbmSelectAddressWrapper;
